import OverviewCard from 'pages/app/overview/overview-cards/OverviewCard.tsx'
import { routes } from 'types/routes.ts'
import ConsumptionSection from 'pages/app/consumption/your-consumption/components/consumption-section/ConsumptionSection.tsx'
import { UsageOverviewCardProps } from 'pages/app/overview/overview-cards/usage/types.ts'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useStoreSelector } from 'hooks/store.ts'
import { ENERGY_TYPES } from '@boltenergy-be/shared'
import { selectIsProducerAccount } from 'store/contact/slice.ts'
import styles from '../../Overview.module.scss'

const UsageOverviewCard = ({ accessRights }: UsageOverviewCardProps) => {
  // Redux store
  const isProducer = useStoreSelector(selectIsProducerAccount)

  // i18n
  const { t } = useTranslation('overview')

  // Local state
  const [hasErrored, setHasErrored] = useState<boolean>(false)

  // Constants
  const translationKey = isProducer ? 'producer' : 'consumer'

  // Conditionally hide
  if (!accessRights.consumption.showContent || hasErrored) return null

  return (
    <OverviewCard
      button={{
        label: t(($) => $.consumption.button[translationKey]),
        href: routes.CONSUMPTION
      }}
    >
      <header>
        <OverviewCard.Title>{t(($) => $.consumption.title[translationKey])}</OverviewCard.Title>
      </header>

      <ConsumptionSection
        compact
        energyType={ENERGY_TYPES.electricity}
        setHide={(v) => setHasErrored(v)}
        chartLayoutClassName={styles['desktop-chart-wrapper']}
      />
    </OverviewCard>
  )
}

export default UsageOverviewCard
